export const COLUMNSCIENTIFICAS = [
    {
        header: 'Fecha',
        accessorKey: 'new_fecha',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Título',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Evento',
        accessorKey: 'new_evento',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Forma de participación',
        accessorKey: 'new_formadeparticipacin',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Lugar',
        accessorKey: 'new_lugar',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]